
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

export interface PlanFeature {
  name: string;
  included: boolean;
}

export interface CurrentPlanCardProps {
  planName: string;
  planId: string;
  description: string;
  features: PlanFeature[];
  createdAt: Date;
}

const CurrentPlanCard: React.FC<CurrentPlanCardProps> = ({
  planName,
  planId,
  description,
  features,
  createdAt
}) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-semibold">{planName}</CardTitle>
          <Badge variant="outline" className="text-blue-600 bg-blue-50 border-blue-200">
            Active
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-600 mb-4">{description}</p>
        
        <div className="mb-4">
          <h4 className="text-sm font-medium mb-2">Plan Features</h4>
          <ul className="space-y-1">
            {features.map((feature, index) => (
              <li key={index} className="text-sm flex items-center">
                <span className={`mr-2 inline-block w-5 h-5 rounded-full flex items-center justify-center text-xs ${
                  feature.included ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'
                }`}>
                  {feature.included ? '✓' : '×'}
                </span>
                {feature.name}
              </li>
            ))}
          </ul>
        </div>
        
        <div className="pt-2 border-t border-gray-100 text-sm text-gray-500 flex items-center">
          <Clock className="h-4 w-4 mr-1" />
          <span>
            Subscribed on {createdAt.toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default CurrentPlanCard;
